import { MMKV } from 'react-native-mmkv';
import ORGANIZATION from '../../native/Constants/organizations.json';
import STORAGE_KEYS from './StorageKeys';
const mmkvStorage = new MMKV();
const mmkvReduxStorage = {
    setItem: (key, value) => {
        mmkvStorage.set(key, value);
        return Promise.resolve(true);
    },
    getItem: (key) => {
        const value = mmkvStorage.getString(key);
        return Promise.resolve(value);
    },
    removeItem: (key) => {
        mmkvStorage.delete(key);
        return Promise.resolve();
    }
};
const setItem = (key, value) => {
    mmkvStorage.set(key, value);
};
const removeItem = (key) => {
    mmkvStorage.delete(key);
};
const getStringItem = (key) => {
    return mmkvStorage.getString(key);
};
const getNumberItem = (key) => {
    return mmkvStorage.getNumber(key);
};
const getBufferItem = (key) => {
    return mmkvStorage.getBuffer(key);
};
export const getTokens = () => {
    return {
        token: getStringItem(STORAGE_KEYS.TOKEN),
        refreshToken: getStringItem(STORAGE_KEYS.REFRESH_TOKEN)
    };
};
export const setTokens = (token, refreshToken) => {
    setItem(STORAGE_KEYS.TOKEN, token);
    setItem(STORAGE_KEYS.REFRESH_TOKEN, refreshToken);
};
export const removeTokens = () => {
    mmkvStorage.delete(STORAGE_KEYS.TOKEN);
    mmkvStorage.delete(STORAGE_KEYS.REFRESH_TOKEN);
};
export const setApiDomain = ({ API_DOMAIN, API_MEETING_DOMAIN, API_SSO_DOMAIN }) => {
    setItem(STORAGE_KEYS.API_DOMAIN, API_DOMAIN);
    setItem(STORAGE_KEYS.API_MEETING_DOMAIN, API_MEETING_DOMAIN);
    setItem(STORAGE_KEYS.API_SSO_DOMAIN, API_SSO_DOMAIN);
};
export const getApiDomains = () => {
    return {
        API_DOMAIN: getStringItem(STORAGE_KEYS.API_DOMAIN) ?? ORGANIZATION[''].API_DOMAIN,
        API_MEETING_DOMAIN: getStringItem(STORAGE_KEYS.API_MEETING_DOMAIN) ?? ORGANIZATION[''].API_MEETING_DOMAIN,
        API_SSO_DOMAIN: getStringItem(STORAGE_KEYS.API_SSO_DOMAIN) ?? ORGANIZATION[''].API_SSO_DOMAIN
    };
};
export const getAllKeys = () => {
    return mmkvStorage.getAllKeys() ?? [];
};
export const setOnChangeValue = (callback) => {
    mmkvStorage.addOnValueChangedListener(callback);
};
export const getDeeplink = () => {
    return getStringItem(STORAGE_KEYS.DEEP_LINK);
};
export const setDeeplink = (url) => {
    mmkvStorage.set(STORAGE_KEYS.DEEP_LINK, url);
};
export const resetDeeplink = () => {
    mmkvStorage.set(STORAGE_KEYS.DEEP_LINK, '');
};
export default {
    getStringItem,
    getNumberItem,
    getBufferItem,
    removeItem,
    mmkvReduxStorage,
    mmkvStorage,
    getAllKeys,
    setOnChangeValue,
    setDeeplink,
    resetDeeplink,
    getDeeplink
};
